import gql from 'graphql-tag';

export const REQUEST_PRICE = gql`
    mutation (
        $priceRequest: PriceRequestInputGraphType,
    ) {
        requestPrice (
            priceRequest: $priceRequest
        ) {
            success
            message
            logId
        }
    }
`